// extracted by mini-css-extract-plugin
export default {"settings":"obnaU","field":"vF2Jp","fileUrlControl":"ZyKnV","button":"l98s1","inner":"sAw1Z","pagesLabel":"eH4s4","pages":"ncACy","page":"VtRup","frames":"Zl3_a","frame":"g_DoQ"};